/**
 * @file 保存
 */

import { API_TYPE, fetchData } from '@umu/umu-fetch';

export const API = {
    ACCOUNT_SEARCH_V2: {
        url: '/api/manage/accessaccountmatchv2',
        type: API_TYPE.POST,
    },
};

enum MEMBER_TYPE {
    USER = 'user',
    GROUP = 'group',
    DEPARTMENT = 'department',
}
interface ISearchUserParam {
    accounts: string;
    search_source: string;
    is_suggestion?: number;
    is_sug?: string;
    group_id?: string;
}
interface IUserResponse {
    data: IUserInfo[];
    error_code: number;
}
interface IUserInfo {
    account: string;
    account_type: MEMBER_TYPE;
    avatar: string;
    email: string;
    id: string;
    is_exist: number;
    login_name: string;
    phone: string;
    student_id: string;
    umu_id: string;
    user_name: string;
}
interface IPagination {
    list_total_num: number;
    total_page_num: number;
    current_page: number;
    size: number;
}

const searchUserListV2 = (param: ISearchUserParam): Promise<IUserInfo[]> => {
    return fetchData(API.ACCOUNT_SEARCH_V2, param, { silent: true }).then((res: IUserResponse) => {
        return res.error_code === 0 ? res.data : [];
    });
};

export {
    IPagination,
    IUserInfo,
    IUserResponse,
    ISearchUserParam,
    searchUserListV2,
    searchUserListV2 as searchUserList,
};
